import { contains, makeFilter } from '@/utils/dynamic'

export default {
  'id': 'labels',
  'mode': {
    'isModalNew': true,
    'isModalEditing': true
  },
  'store': {
    'get': {
      'url': 'Labels/GetAllDynamic',
      'selected': 'id,languageID,labelKey,title,language.title as language'
    },
    'create': {
      'url': 'Labels/Create'
    },
    'patch': {
      // eslint-disable-next-line no-template-curly-in-string
      'url': 'Labels/Patch/${data.id}'
    },
    'delete': {
      // eslint-disable-next-line no-template-curly-in-string
      'url': 'Labels/Delete/${data.id}'
    }
  },
  'columns': [
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('label-key')}",
      'field': 'labelKey',
      'classes': 'column-size-small',
      'editor': {
        'type': 'string',
        'required': true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('title')}",
      'field': 'title',
      'classes': 'column-size-small',
      'editor': {
        'type': 'string',
        'required': true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('language')}",
      'field': 'language'
    }
  ],
  'rowControls': {
    'right': {
      'controls': [
        'edit'
      ]
    }
  },
  'header': {
    'controls': {
      'isVisible': true,
      'export': {
        'json': {
          'current': {
            'isVisible': false
          },
          'all': {
            'isVisible': false
          }
        }
      }
    }
  },
  'toolbar': {
    'filters': [
      {
        'type': 'string',
        'field': 'labelKey',
        'options': {
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('search')}",
          valueTemplate: ({ value }) =>
            makeFilter(['labelKey', 'title'], value, contains),
          'styles': {
            'minWidth': '15rem'
          }
        }
      },
      {
        'type': 'select',
        'field': 'languageID',
        'options': {
          'dataSource': 'Languages/GetAllDynamic?select=id,title',
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('select-language')}",
          'styles': {
            'minWidth': '25rem'
          }
        }
      }
    ]
  }
}
